<template>
  <div class="award-wrapper mt-5">
    <div class="container">
      <h2 class="center" v-html="$t(`products.${$route.name}.weTrain`)"></h2>
      <div class="awards-img">
        <div class="award-img">
          <img src="@/assets/training/1.png">
        </div>
        <div class="award-img">
          <img src="@/assets/training/2.png">
        </div>
        <div class="award-img">
          <img src="@/assets/training/3.png">
        </div>
        <div class="award-img">
          <img src="@/assets/training/4.png">
        </div>
        <div class="award-img">
          <img src="@/assets/training/5.png">
        </div>
        <div class="award-img">
          <img src="@/assets/training/6.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Awards'
}
</script>

<style lang="sass" scoped>
.center
  text-align: center
  padding-top: 20px

.award-wrapper
  padding: 80px 0 100px
  color: $black
  position: relative
  width: 100vw
  height: 100%
  left: 50%
  transform: translateX(-50vw)
  z-index: 0
  background-color: #FFF8D1

.awards-img
  display: flex
  grid-gap: 40px
  margin-top: 50px
  justify-content: space-around
  align-items: center
  padding: 0 50px
  +media-breakpoint-down(md)
    grid-gap: 30px
    padding: 0
  +media-breakpoint-down(sm)
    grid-gap: 20px
  +media-breakpoint-down(xs)
    grid-gap: 20px 15px
  @media screen and (max-width: 480px)
    flex-wrap: wrap

  .award-img
    width: 130px
    text-align: center

    @media screen and (max-width: 480px)
      max-width: 33%
      width: unset

  img
    max-height: 50px
    max-width: 100%
</style>



// WEBPACK FOOTER //
// src/components/ui/products/WeTrain.vue